export default {
    id: "646e843f-2185-43fa-9c67-b97e7fc337cd",
    icon: "mdi-radiobox-marked",
    name: "inputRadiobutton",
    title: "Radio Button",
    description: "A radiobutton",
}